import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useApp } from "../../context/AppState";
import { getCartDrawerSlotShellStyle } from "../../utils/sectionBlockCss";

/** Flow shell: editor dimension + layer; block components keep schema customCSS inside. */
export default function CartDrawerBlockShell({
  children,
  className,
  style,
  section,
}) {
  const { isMobile } = useApp();

  const shellStyle = useMemo(() => {
    const base = section
      ? getCartDrawerSlotShellStyle(section, isMobile, style)
      : {
          position: "relative",
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          boxSizing: "border-box",
          ...style,
        };

    return base;
  }, [section, isMobile, style]);

  return (
    <div
      className={
        className
          ? `weupsell-cart-drawer-block weupsell-cart-drawer-block-slot ${className}`
          : "weupsell-cart-drawer-block weupsell-cart-drawer-block-slot"
      }
      style={shellStyle}
    >
      {children}
    </div>
  );
}

CartDrawerBlockShell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  section: PropTypes.object,
};
